import React from 'react'
import { Marker as GoogleMapMarker } from 'react-google-maps'

const Marker = props => {
  return <GoogleMapMarker {...props} icon={props.icon} />
}

export { Marker }



// WEBPACK FOOTER //
// ./src/Components/Map/Marker.js